import { success, failure, request } from 'app/actions';
import * as actions from './onlineSimulatedActions';
import * as helpers from './onlineSimulatedHelpers';

const initialState = {
  evaluationsOnline: [],
  years: [],
  isLoading: false,
  hasError: false,
  error: '',
  evaluation: {},
  finishAssessment: false,
  essayDetails: {},
  errorEssaySaveMessage: '',
  essaySaved: false,
  essaySaving: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.GET_EVALUATIONS_ONLINE):
      return {
        ...state,
        isLoading: true,
        evaluationsOnline: [],
        finishAssessment: initialState.finishAssessment,
      };
    case success(actions.GET_EVALUATIONS_ONLINE):
      return {
        ...state,
        isLoading: false,
        evaluationsOnline: helpers.getEvaluationsOnline(action.payload.content),
        years: helpers.getYears(action.payload.content),
      };
    case request(actions.ANSWER_EVALUATION_ONLINE):
      return {
        ...state,
        isLoading: true,
        finishAssessment: initialState.finishAssessment,
      };
    case success(actions.ANSWER_EVALUATION_ONLINE):
      return {
        ...state,
        isLoading: false,
        evaluation: action.payload.content,
      };
    case request(actions.ANSWER_QUESTION):
      return {
        ...state,
        isLoading: true,
        finishAssessment: initialState.finishAssessment,
      };
    case success(actions.ANSWER_QUESTION):
      return {
        ...state,
        isLoading: false,
        message: action.payload.content,
      };
    case request(actions.FINISH_SCHEDULED_ASSESSMENT):
      return {
        ...state,
        isLoading: true,
        finishAssessment: initialState.finishAssessment,
      };
    case success(actions.FINISH_SCHEDULED_ASSESSMENT):
      return {
        ...state,
        isLoading: false,
        finishAssessment: true,
      };
    case request(actions.VIEW_EVALUATION_ONLINE):
      return {
        ...state,
        isLoading: true,
        evaluation: initialState.evaluation,
      };
    case success(actions.VIEW_EVALUATION_ONLINE):
      return {
        ...state,
        isLoading: false,
        evaluation: action.payload.content,
      };
    case request(actions.GET_EVALUATION_ESSAY_DETAILS):
      return {
        ...state,
        isLoading: true,
        essayDetails: initialState.essayDetails,
      };
    case success(actions.GET_EVALUATION_ESSAY_DETAILS):
      return {
        ...state,
        isLoading: false,
        essayDetails: action.payload.content,
      };
    case request(actions.SAVE_EVALUATION_ESSAY_TEXT):
      return {
        ...state,
        errorEssaySaveMessage: initialState.errorEssaySaveMessage,
        essaySaved: initialState.essaySaved,
        essaySaving: true,
      };
    case success(actions.SAVE_EVALUATION_ESSAY_TEXT):
      return {
        ...state,
        essaySaved: true,
        essaySaving: false,
        errorEssaySaveMessage: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
